import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSessionContext } from '~/contexts/session.context';
import PendoService from '~/services/pendo';

export function PendoPageTracker() {
  const { isAuth } = useSessionContext();
  const location = useLocation();

  useEffect(() => {
    // Only track pages for authenticated users
    if (isAuth && PendoService.isInitialized) {
      // Small delay to ensure the page has fully loaded
      const timeoutId = setTimeout(() => {
        PendoService.pageLoad();
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [location.pathname, isAuth]);

  // This component doesn't render anything
  return null;
} 